module.exports = {
	'bootstrap': require('./lib/bootstrap-variables.json')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/toetag/index.js
// module id = 1032
// module chunks = 0